export const getDateFormat = () => {
  var offset = new Date().getTimezoneOffset();
  var abs_offset = Math.abs(offset)
  var tz = ("" + (Math.floor(abs_offset / 60))).padStart(2, "0") +
     ":" + ("" + (abs_offset % 60)).padStart(2, "0")
  var tzs = offset < 0 ? "+" : "-"
  return `YYYY-MM-DDTHH:mm:ss${tzs}${tz}`
}
